import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=49a04bf3&"
import script from "./AppButton.vue?vue&type=script&lang=ts&"
export * from "./AppButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports